<template>
    <div v-if="user" class="p-3">
        <b-card
            title="Tambah Kuota Poli"
        >
            <b-card-text>
                <b-button variant="danger" class="mt-5" @click="cancelAdd">Kembali</b-button>
                <form class="mt-5">
                    <div class="row">
                        <div class="col">
                            <div class="form-group row pb-4">
                                <label class="col-lg-3 text-lg-end pt-2">Jadwal</label>
                                <div class="col">
                                    <b-form-radio-group
                                        id="radio-group-1"
                                        v-model="form.minggu"
                                    >
                                        <b-form-radio value="1">&nbsp;Minggu Ini</b-form-radio>
                                        <b-form-radio value="2">&nbsp;Minggu Depan</b-form-radio>
                                </b-form-radio-group>
                                </div>
                            </div>
                            <div class="form-group row pb-4">
                                <label class="col-lg-3 text-lg-end pt-2" for="select-poli">Poli</label>
                                <div class="col">
                                    <select2 id="select-poli" v-model="form.poli" :options="all_poli_options" @change="getKonfigurasiKuotaPoli"></select2>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div id="tabledata-kuota-poli" class="mt-3"></div>
                </form>
            </b-card-text>
        </b-card>
    </div>
</template>

<script>
import Select2 from 'v-select2-component'

export default {
    components: {
        Select2
    },
    data() {
        return {
            table: null,
            table_data: [],
            user: null,
            access_token: null,
            item_per_page: 10,
            total_rows: 0,
            page: 1,
            table: null,
            paging_data: {
                from: 0,
                to: 0,
                total: 0
            },
            form: {
                minggu: '2',
                poli: 0,
                dokter: 0,
                kuota: 0,
            },
            all_poli_options: [{id: 0, text: '--- Pilih Poli ---'}],
            dokter_poli_options: [{id: 0, text: '--- Pilih Poli ---'}],
        }
    },
    created() {
        this.getAuth()
    },
    methods: {
        getAuth() {
            this.user = localStorage.getItem('user')
            this.access_token = localStorage.getItem('access_token')

            this.getPoli()
        },
        getPoli() {
            this.$isLoading(true)
            let uri = '/api/allpoli?feature=create'

            let headers = {
                headers: {
                    Accept: 'application/json',
                    Authorization: 'Bearer ' + this.access_token
                }
            }

            this.axios.get(uri, headers).then(response => {
                this.all_poli_options = [{id: 0, text: '--- Pilih Poli ---'}]

                let all_poli = response.data.all_poli
                all_poli.forEach(ap => {
                    this.all_poli_options.push({id: ap.KDPoli, text: ap.KDPoli + ' - ' + ap.NMPoli})
                });

                this.$isLoading(false)
            }).catch((error) => {
                this.$isLoading(false)
                let response = error.response != undefined ? error.response : null
                if (response) {
                    if (response.status == 401) {
                        localStorage.setItem('access_token', '')
                        localStorage.setItem('user', '')
                        location.href = '/login'
                    }
                }
            })
        },
        getKonfigurasiKuotaPoli() {
            if (this.form.poli > 0) {
                this.$isLoading(true)
                let query_page = this.page ? '&page=' + this.page : ''
                let uri = '/api/konfkuotapoli?per_page=' + this.item_per_page + query_page + '&search=' + this.form.poli + '&minggu=' + this.form.minggu + '&type=create'

                let headers = {
                    headers: {
                        Accept: 'application/json',
                        Authorization: 'Bearer ' + this.access_token
                    }
                }

                this.axios.get(uri, headers).then(response => {
                    if (response.data.status == 'success') {
                        this.option_poli = [{id: 0, text: '--- Pilih Poli ---'}]
                        let data_poli = response.data.data_poli

                        data_poli.forEach(dp => {
                            this.option_poli.push({id: dp.poli_data.KDPoli, text: dp.poli_data.NMPoli})
                        });

                        this.table_data = response.data.konfigurasi_kuota_poli.data
                        this.total_rows = response.data.konfigurasi_kuota_poli.total
                        this.paging_data = {
                            from: response.data.konfigurasi_kuota_poli.from,
                            to: response.data.konfigurasi_kuota_poli.to,
                            total: response.data.konfigurasi_kuota_poli.total
                        }

                        let jadwal_actions = function (cell, formatterParams) {
                            return '<a class="btn btn-success btn-sm" id="but-save"><i class="fa fa-floppy-o" aria-hidden="true" id="save"></i></a><a class="btn btn-danger btn-sm" id="but-delete"><i class="fa fa-trash" aria-hidden="true" id="delete"></i></a>'
                        }

                        this.table = new Tabulator('#tabledata-kuota-poli', {
                            layout:"fitColumns",
                            data: this.table_data[0].jadwal_dokter,
                            columns:[
                                {width: '150', title: 'Kode DPJP', field: 'kode_dokter_bpjs', headerSort: true, editor: 'input'},
                                {width: '500', title: 'Nama Dokter', field: "nama_dokter", headerSort: true},
                                {width: '150', title: 'Hari', field: "nama_hari", headerSort: true},
                                {width: '150', title: 'Kapasitas Pasien', field: "kapasitas_pasien", headerSort: true, editor: 'number'},
                                {width: '150', title: 'Jam Mulai', field: "jam_mulai", headerSort: false, editor: 'input'},
                                {width: '150', title: 'Jam Selesai', field: "jam_selesai", headerSort: false, editor: 'input'},
                                {width: '100', title: 'Aksi', formatter: jadwal_actions, headerSort: false, cellClick: this.jadwalActions}
                            ],
                            initialSort:[
                                {column: 'kd_dokter_bpjs', dir:"asc"}, //sort by this first
                            ]
                        })
                    } else {
                        this.$swal.fire({
                            title: 'Error!',
                            text: response.data.message,
                            icon: 'error',
                            confirmButtonText: 'OK'
                        })
                    }

                    this.$isLoading(false)
                }).catch((error) => {
                    this.$isLoading(false)
                    let response = error.response != undefined ? error.response : null
                    if (response) {
                        if (response.status == 401) {
                            localStorage.setItem('access_token', '')
                            localStorage.setItem('user', '')
                            location.href = '/login'
                        }
                    }
                })
            }
        },
        jadwalActions(e, cell) {
            let data = cell.getRow().getData()
            let type = e.target.id

            if (type == 'but-save' || type == 'save') {
                this.updateJadwalDokter(data.kd_poli, data.kd_dokter, data.hari, data.jam_mulai, data.jam_selesai, data.kapasitas_pasien)
            } else if (type == 'but-delete' || type == 'delete') {
                alert('delete')
            }
        },
        getDokterPoli() {
            this.$isLoading(true)
            let uri = '/api/getdokterpoli?poli=' + this.form.poli

            let headers = {
                headers: {
                    Accept: 'application/json',
                    Authorization: 'Bearer ' + this.access_token
                }
            }

            this.axios.get(uri, headers).then(response => {
                this.dokter_poli_options = [{id: 0, text: '--- Pilih Dokter ---'}]

                let dokter_poli = response.data.dokters
                dokter_poli.forEach(dp => {
                    this.dokter_poli_options.push({id: dp.KdDoc, text: dp.KdDPJP + ' - ' + dp.NmDoc})
                });

                this.$isLoading(false)
            }).catch((error) => {
                this.$isLoading(false)
                let response = error.response != undefined ? error.response : null
                if (response) {
                    if (response.status == 401) {
                        localStorage.setItem('access_token', '')
                        localStorage.setItem('user', '')
                        location.href = '/login'
                    }
                }
            })
        },
        addDokter() {
            this.getDokterPoli()
        },
        updateJadwalDokter(kd_poli, kd_dokter, hari, buka, tutup, kapasitas_pasien) {
            this.$isLoading(true)
            let uri = '/api/update_jadwal_dokter'

            let headers = {
                headers: {
                    Accept: 'application/json',
                    Authorization: 'Bearer ' + this.access_token
                }
            }

            let data_update = {
                kd_poli: kd_poli,
                kd_dokter: kd_dokter,
                hari: hari,
                buka: buka,
                tutup: tutup,
                kapasitas_pasien: kapasitas_pasien,
            }

            this.axios.post(uri, data_update, headers).then(response => {
                let message = response.data.message
                alert(message)

                this.$isLoading(false)
            }).catch((error) => {
                this.$isLoading(false)
                let response = error.response != undefined ? error.response : null
                if (response) {
                    if (response.status == 401) {
                        localStorage.setItem('access_token', '')
                        localStorage.setItem('user', '')
                        location.href = '/login'
                    }
                }
            })
        },
        cancelAdd() {
            this.$router.push('konfigurasi-kuota-poli')
        }
    }
}
</script>
